{
  "version": 1,
  "asset_id": "02bd81e3-6e1e-4073-820b-5b743b880f4d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/02bd81e3-6e1e-4073-820b-5b743b880f4d/loc-houston-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/02bd81e3-6e1e-4073-820b-5b743b880f4d/loc-houston-640.avif",
  "original_filename": "loc-houston-640.avif",
  "size": 17908,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:27Z"
}
